import { render, staticRenderFns } from "./editBeneficio.vue?vue&type=template&id=1568d3b6"
import script from "./editBeneficio.vue?vue&type=script&lang=js"
export * from "./editBeneficio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports